import {
    TOW_DRIVERS_FILTER_UPDATE
} from '../../mutation-types';

export default {
    [TOW_DRIVERS_FILTER_UPDATE](state, ui) {
        state.filter = ui;
    },
};
